import { TTypeOfCodec } from "../../shared/src/codecs/codec";
import { array } from "../../shared/src/codecs/types/array";
import { boolean } from "../../shared/src/codecs/types/boolean";
import { literal } from "../../shared/src/codecs/types/literal";
import { nonEmptyArray } from "../../shared/src/codecs/types/nonEmptyArray";
import { required } from "../../shared/src/codecs/types/required";
import { string } from "../../shared/src/codecs/types/string";
import { union } from "../../shared/src/codecs/types/union";
import { uuid } from "../../shared/src/codecs/types/uuid";
import { CasesDocumentType } from "./CasesDocumentTypes";


export const FileEmailAttachmentsToDocStorePath1 = required({
    case_id: uuid(),
    email_id: uuid(),
});
export type TFileEmailAttachmentsToDocStorePath1 = TTypeOfCodec<typeof FileEmailAttachmentsToDocStorePath1>;

export const FileEmailAttachmentsToDocStoreAssignmentTargetExistingTile1 = required({
    tag: literal("existing_tile"),
    cases_document_id: uuid(),
});
export type TFileEmailAttachmentsToDocStoreAssignmentTargetExistingTile1 = TTypeOfCodec<typeof FileEmailAttachmentsToDocStoreAssignmentTargetExistingTile1>;

export const FileEmailAttachmentsToDocStoreAssignmentTargetNewTile1 = required({
    tag: literal("new_tile"),
    type: CasesDocumentType,
    additional_name: string(),
});
export type TFileEmailAttachmentsToDocStoreAssignmentTargetNewTile1 = TTypeOfCodec<typeof FileEmailAttachmentsToDocStoreAssignmentTargetNewTile1>;

export const FileEmailAttachmentsToDocStoreAssignmentTarget1 = union([
    FileEmailAttachmentsToDocStoreAssignmentTargetExistingTile1,
    FileEmailAttachmentsToDocStoreAssignmentTargetNewTile1,
]);
export type TFileEmailAttachmentsToDocStoreAssignmentTarget1 = TTypeOfCodec<typeof FileEmailAttachmentsToDocStoreAssignmentTarget1>;

export const FileEmailAttachmentsToDocStoreAssignment1 = required({
    legal_file_download_tokens: nonEmptyArray(string()),
    target: FileEmailAttachmentsToDocStoreAssignmentTarget1,
});
export type TFileEmailAttachmentsToDocStoreAssignment1 = TTypeOfCodec<typeof FileEmailAttachmentsToDocStoreAssignment1>;

export const FileEmailAttachmentsToDocStoreBody1 = required({
    assignments: nonEmptyArray(FileEmailAttachmentsToDocStoreAssignment1),
});
export type TFileEmailAttachmentsToDocStoreBody1 = TTypeOfCodec<typeof FileEmailAttachmentsToDocStoreBody1>;

export const CaseDocumentTileInfo1 = required({
    cases_document_id: uuid(),
    type: CasesDocumentType,
    additional_name: string(),
    awaiting: boolean(),
});
export type TCaseDocumentTileInfo1 = TTypeOfCodec<typeof CaseDocumentTileInfo1>;

export const GetCaseDocumentTilesPath1 = required({
    case_id: uuid(),
});
export type TGetCaseDocumentTilesPath1 = TTypeOfCodec<typeof GetCaseDocumentTilesPath1>;

export const GetCaseDocumentTilesResponse1 = required({
    tiles: array(CaseDocumentTileInfo1),
});
export type TGetCaseDocumentTilesResponse1 = TTypeOfCodec<typeof GetCaseDocumentTilesResponse1>;
